/*eslint-disable*/
import api from '../'

class vocabularyWordsGameItems {
    static getVocabularyWords (params) {
        return api.axios.post('/getVocabularyWords', params).then(response => response.data.couples);
    }
}

export default vocabularyWordsGameItems;
